import React, { useState } from 'react';
import axios from '../AxiosConfig';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post('/api/auth/forgotPassword', { email });
      setSuccessMessage(response.data.message);
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(error.response?.data?.error || 'Failed to send reset email');
      setSuccessMessage(null);
    }
  };

  return (
    <Container className="mt-5">
      <Card className="shadow-lg p-4">
        <Card.Body>
          <h2 className="text-center mb-4">Reset Password</h2>
          {successMessage && <Alert variant="success">{successMessage}</Alert>}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <Form>
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" onClick={handleForgotPassword} className="w-100">
              Send Reset Link
            </Button>
          </Form>
          <div className="mt-3 text-center">
            <span onClick={() => navigate('/login')} style={{ cursor: 'pointer', color: 'blue' }}>
              Back to Login
            </span>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ForgotPassword;
